import { Field } from 'formik';

const NumberBox = ({
  label,
  name,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleChange,
  max,
  min,
  step,
  errormsg,
  fieldFlag,
  disabled,
}) => {
  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <Field
        className={`formik-input${disabled ? ' disabled' : ''}`}
        type="number"
        name={name}
        disabled={disabled}
        // fullwidth
        style={{ width: '100%' }}
        autoComplete="given-name"
        id={'number-' + name}
        variant="outlined"
        value={value ?? defaultValue ?? 0}
        onChange={(e) => handleChange(e, fieldFlag)}
        {...(max && max > 0 ? { max: max } : 9999999999)}
        {...(min && min > 0 ? { min: min } : 0)}
        {...(step ? { step: step } : {})}
        {...(placeholder ? { placeholder: placeholder } : {})}
      />
      {errormsg && <div className="error-message">{errormsg}</div>}
    </>
  );
};

export default NumberBox;
